import Homepage from 'src/screens/homepage/homepage';
export default Homepage;
